var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9909 21.3261V10.663C27.9904 10.1955 27.867 9.73641 27.6331 9.33168C27.3991 8.92695 27.0629 8.59086 26.658 8.35713L17.3278 3.0256C16.9226 2.79163 16.4629 2.66846 15.995 2.66846C15.527 2.66846 15.0673 2.79163 14.6621 3.0256L5.3319 8.35713C4.92706 8.59086 4.5908 8.92695 4.35685 9.33168C4.12291 9.73641 3.9995 10.1955 3.99902 10.663V21.3261C3.9995 21.7935 4.12291 22.2527 4.35685 22.6574C4.5908 23.0621 4.92706 23.3982 5.3319 23.6319L14.6621 28.9635C15.0673 29.1974 15.527 29.3206 15.995 29.3206C16.4629 29.3206 16.9226 29.1974 17.3278 28.9635L26.658 23.6319C27.0629 23.3982 27.3991 23.0621 27.6331 22.6574C27.867 22.2527 27.9904 21.7935 27.9909 21.3261Z",
    stroke: "current",
    strokeWidth: 1.99932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3584 9.27698L15.9945 16.008L27.6305 9.27698",
    stroke: "current",
    strokeWidth: 1.99932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9932 29.4303V15.9949",
    stroke: "current",
    strokeWidth: 1.99932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.776af2c11a4300c238f6e9af25a04c15.svg";
export { ForwardRef as ReactComponent };